import React, { useEffect } from 'react';

const PrivacyPolicy = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
        }, []);

    return (
        <div className="privacy-policy">
            <div className="section">
            <h2>Privacy Policy</h2>
                <p>
                    At Rhodiumroot we are committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use Rhodiumroot.com and/or the Rhodium Life mobile application (collectively, the "Services").
                </p>
                <h3>Rhodium Life App Privacy Summary</h3>
                <p>
                    Rhodium Life is designed to keep your health data on your device. We do not store your personal health information on external servers.
                    If you use AI features, only the specific data you choose to analyze may be sent to the AI provider you configure.
                </p>
                <h3>Information We May Collect</h3>
                <p>We collect information that you provide directly to us, including:</p>
                <ul>
                    <li>Name and contact information</li>
                    <li>Account credentials</li>
                    <li>Health and Nutrition information</li>
                    <li>
                        Health &amp; Fitness Data: With your permission, we access health and fitness data from Apple HealthKit,
                        including but not limited to exercise minutes, sleep data, heart rate, and activity data. This data is
                        used solely to provide app functionality and is never sold, shared with advertisers, or used for any
                        purpose other than operating the app.
                    </li>
                    <li>Communication preferences</li>
                </ul>
                <p>
                    We may automatically collect certain information when you use our service.
                </p>
                <ul>
                    <li>Device information</li>
                    <li>Log data</li>
                    <li>Usage information</li>
                    <li>Cookies and similar technologies</li>
                </ul>
                <h3>Health Data (Rhodium Life App)</h3>
                <p>
                    If you use the Rhodium Life mobile application, you may choose to connect Apple HealthKit. When enabled, the app may read health data to track biomarkers and calculate health risk scores, and may write health data to Apple HealthKit when you import biomarkers.
                </p>
                <h3>HealthKit Data</h3>
                <p>
                    HealthKit RhodiumLife integrates with Apple HealthKit to read and display your health metrics. We do not store HealthKit data on external servers. All HealthKit data remains on your device. We do not share HealthKit data with third parties except as required to provide core app features (e.g., sending relevant health context to an AI provider you have explicitly configured). HealthKit data is never used for advertising or sold to data brokers.
                </p>
                <h3>Photos, PDF, and CSV Imports (Rhodium Life App)</h3>
                <p>
                    The Rhodium Life app may request access to your photo library to import supplement labels and nutrition information using AI analysis. The app may also allow you to import lab results and data using supported file types such as PDF and CSV.
                </p>
                <h3>How We Use Your Information</h3>
                <p>We use the collected information for several function to improve the service provided.</p>
                <ul>
                    <li>Providing and maintaining our services</li>
                    <li>Processing your transactions</li>
                    <li>Communicating with you</li>
                    <li>Improving our services</li>
                    <li>Complying with legal obligations</li>
                </ul>
                <h3>AI Features and Third-Party AI Providers (Rhodium Life App)</h3>
                <p>
                    Rhodium Life supports AI features using third-party providers. You may configure an OpenAI-compatible provider (including cloud services) or a local provider (such as Ollama or LM Studio).
                    If you use AI features, only the specific data needed for the requested analysis may be sent to your configured provider (for example, flagged biomarker values, workout parameters, and weekly exercise data if connected to Apple Health).
                    Your use of any third-party AI provider is subject to that provider's terms and privacy policy.
                </p>
                <h3>Information Sharing and Disclosure</h3>
                <p>We may share your information with some third parities based on the application interaction or legal request.</p>
                <ul>
                    <li>Service providers and business partners</li>
                    <li>Legal authorities when required by law</li>
                    <li>Other parties with your consent</li>
                </ul>
                <h3>Data Security</h3>
                <p>
                    We implement appropriate technical and organizational measures to protect your personal information.
                    However, no method of transmission over the Internet is 100% secure.
                </p>
                <h3>Your Rights</h3>
                <p>You have the basic rights associated with your information.</p>
                <ul>
                    <li>Access to your personal information</li>
                    <li>Correct inaccurate information</li>
                    <li>Request deletion of your information</li>
                </ul>
                <h3>Cookies</h3>
                <p>
                    We may use cookies and similar tracking technologies to track activity on our service and hold certain
                    information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being
                    sent.
                </p>
                <h3>Children's Privacy</h3>
                <p>
                    Our service is not directed to children under 13. We do not knowingly collect personal information
                    from children under 13. If you become aware that a child has provided us with personal information,
                    please contact us.
                </p>
                <h3>Changes to This Privacy Policy</h3>
                <p>
                    We may update our Privacy Policy from time to time. Any changes to update the Privacy Policy will be posted on this page.
                </p>
                <p>
                    For the Rhodium Life mobile application, the most current version of the Privacy Policy may be presented in-app. Due to differences in publication timing (including App Store review and release timing), there may be periods where the website and in-app Privacy Policy do not match. In such cases, the Privacy Policy presented in the Rhodium Life app will govern for your use of the Rhodium Life app.
                </p>
                <h3>Contact Us</h3>
                <p>
                    If you have any questions about this Privacy Policy, please contact us at: support@rhodiumroot.com
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
